import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
  selector: 'oph-input-animate',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './oph-input-animate.component.html',
  styleUrl: './oph-input-animate.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphInputAnimateComponent implements OnInit, OnDestroy {
  @Input() control: FormControl;
  @Input() placeholder: string = '';
  @Input() suffix: string = '';
  @Input() type: string = 'text';
  @Input() maxlength: number;

  // Styling customization inputs
  @Input() fontSize: string = '16px';
  @Input() fontWeight: string = '500';
  @Input() textColor: string = '#000000';
  @Input() borderRadius: string = '6px';
  @Input() placeholderFontSize: string = '14px';
  @Input() placeholderColor: string = '#999999';
  @Input() backgroundColor: string = '#ffffff';
  @Input() borderColor: string = 'transparent';
  @Input() focusBorderColor: string = 'var(--blue)';
  @Input() focusBackgroundColor: string = '#ffffff';
  @Input() suffixColor: string = '#999999';
  @Input() suffixBackgroundColor: string = '#ffffff';
  @Input() height: string = '50px';

  isFocused = false;
  private formControlSubscription: Subscription | null = null;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    if (this.control) {
      // Subscribe to FormControl value changes to trigger change detection
      this.formControlSubscription = this.control.valueChanges.subscribe(() => {
        this.cdr.markForCheck();
      });
    }
  }

  ngOnDestroy() {
    if (this.formControlSubscription) {
      this.formControlSubscription.unsubscribe();
    }
  }

  get hasValue(): boolean {
    if (this.control) {
      const controlValue = this.control.value;
      return controlValue !== null && controlValue !== '' && controlValue !== undefined;
    }
    return false;
  }

  get shouldFloat(): boolean {
    return this.isFocused || this.hasValue;
  }

  onFocus() {
    this.isFocused = true;
  }

  onBlur() {
    this.isFocused = false;
  }
}
